import type { MatchConfidence } from '../../types/api';

/**
 * A confiança precisa ser explicável: `score` sem evidência é número mágico, e
 * número mágico em decisão sobre pessoa é inaceitável (SPEC-005 §6). A tela
 * mostra as evidências em português, nunca o enum.
 */
const EVIDENCE_LABELS: Record<string, string> = {
  exact_username: 'nome de usuário idêntico',
  profile_url_match: 'endereço informado aponta para este perfil',
  username_similarity: 'nome de usuário parecido',
  name_exact: 'nome idêntico',
  name_similarity: 'nome contém o que você informou',
  verified_account: 'conta verificada',
  bio_mention: 'a biografia menciona o que você buscou',
  location_mention: 'a biografia cita o local informado',
  co_occurrence: 'aparece junto de outros termos buscados',
  established_account: 'conta com histórico e alcance',
  sparse_profile: 'perfil com pouquíssimo conteúdo público',
  homonym_crowd: 'vários perfis com este mesmo nome',
};

export function evidenceLabel(evidence: string): string {
  return EVIDENCE_LABELS[evidence] ?? evidence;
}

/** Evidências que enfraquecem a confiança, e por isso são exibidas à parte. */
const NEGATIVE = new Set(['sparse_profile', 'homonym_crowd']);

export function isNegative(evidence: string): boolean {
  return NEGATIVE.has(evidence);
}

/**
 * Rótulos de confiança. Nenhum deles afirma identidade — "provável" é o
 * máximo que o sistema pode dizer, porque quem decide é quem pesquisa (§11).
 */
export const CONFIDENCE_LABELS: Record<MatchConfidence, string> = {
  high: 'Correspondência provável',
  medium: 'Correspondência possível',
  low: 'Correspondência incerta',
};

export const CONFIDENCE_TONE: Record<MatchConfidence, 'success' | 'warning' | 'neutral'> = {
  high: 'success',
  medium: 'warning',
  low: 'neutral',
};
